import React from 'react';
import TrainerTable from '../../components/Tables/TrainerTable';
import './TrainerPage.css'; // Si existe

const TrainerPage = () => {
  return (
    <div className="page-container">
      <TrainerTable />
    </div>
  );
};
export default TrainerPage;